export const profileData = {
  name: "Venkatamanas Raghupatruni",
  title: "Data Scientist",
  tagline: "Turning Data Into Stories, Coffee Into Code",
  bio: "Data Scientist with 4+ years of experience designing and deploying machine learning and AI solutions that drive measurable business impact. Skilled in end-to-end ML pipelines, cloud deployment (AWS, GCP, Azure), advanced statistical analysis, and data visualization. Passionate about solving real-world problems through predictive modeling, deep learning, NLP, and time-series forecasting.",
  email: "raghupatrunivenkatamanas@gmail.com",
  github: "https://github.com/Manas470",
  linkedin: "https://www.linkedin.com/in/venkatamanas/",
  resume: "https://drive.google.com/file/d/1Ze3V7zPOUroUCd_GPouejjVMd54WoeIB/view?usp=sharing",
  location: "Currently working at Crunch Fitness",
  yearsOfExperience: 4,
  profileImage: "https://avatars.githubusercontent.com/u/126650247?v=4"
};

export const skills = [
  {
    category: "Programming Languages",
    items: ["Python", "SQL", "JavaScript", "C++", "Java"]
  },
  {
    category: "ML/AI Frameworks",
    items: ["TensorFlow", "PyTorch", "Scikit-learn", "Keras", "OpenCV"]
  },
  {
    category: "Data Analysis & Visualization",
    items: ["Pandas", "NumPy", "Matplotlib", "Seaborn", "Plotly"]
  },
  {
    category: "Cloud & DevOps",
    items: ["AWS", "GCP", "Azure", "Docker", "Kubernetes"]
  },
  {
    category: "Databases",
    items: ["PostgreSQL", "MySQL", "MongoDB", "Redis", "Snowflake"]
  },
  {
    category: "Big Data & Tools",
    items: ["Hadoop", "Apache Hive", "Spark", "Git", "MLOps"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Amazon Reviews Sentiment Analysis",
    description: "Built an NLP model to analyze customer sentiment from Amazon reviews using advanced text preprocessing, feature extraction, and deep learning techniques. Achieved 92% accuracy in sentiment classification.",
    technologies: ["Python", "NLTK", "TensorFlow", "Scikit-learn", "Pandas"],
    github: "https://github.com/Manas470/Data-Science-Projects/tree/main/Amazon%20Reviews%20Sentiment%20Analysis",
    category: "NLP"
  },
  {
    id: 2,
    title: "Cyber Bullying Tweet Classification",
    description: "Developed a machine learning model to detect and classify cyberbullying in tweets. Implemented multi-class classification with BERT embeddings to identify different types of harmful content.",
    technologies: ["Python", "BERT", "PyTorch", "NLP", "Text Mining"],
    github: "https://github.com/Manas470/Data-Science-Projects/tree/main/Cyber%20Bullying%20Tweet%20Classification",
    category: "NLP"
  },
  {
    id: 3,
    title: "Global Coffee Trends Analysis",
    description: "Strategic business intelligence project analyzing global coffee market trends to identify expansion opportunities. Utilized advanced data analytics and visualization techniques for actionable insights.",
    technologies: ["Python", "Pandas", "Tableau", "Statistical Analysis", "Data Viz"],
    github: "https://github.com/Manas470/Data-Science-Projects/tree/main/Global%20Coffee%20Trends%20%E2%80%93%20Insights%20for%20Strategic%20Expansion",
    category: "Analytics"
  },
  {
    id: 4,
    title: "Google Stock Price Prediction",
    description: "Time-series forecasting model using LSTM neural networks to predict Google stock prices. Implemented feature engineering with technical indicators and achieved strong predictive performance.",
    technologies: ["Python", "LSTM", "TensorFlow", "Time Series", "NumPy"],
    github: "https://github.com/Manas470/Data-Science-Projects/tree/main/Google%20Stock%20Price%20Prediction",
    category: "Time Series"
  },
  {
    id: 5,
    title: "Predictive Maintenance Application",
    description: "End-to-end ML application for predicting equipment failures before they occur. Deployed on cloud infrastructure with real-time monitoring and alerting capabilities.",
    technologies: ["Python", "Scikit-learn", "AWS", "Flask", "Docker"],
    github: "https://github.com/Manas470/Data-Science-Projects/tree/main/Predictive-Maintenance-App",
    category: "ML Application"
  },
  {
    id: 6,
    title: "Web Scraping Framework",
    description: "Built a robust web scraping framework for automated data collection from multiple sources. Implemented data cleaning, transformation, and storage pipelines.",
    technologies: ["Python", "BeautifulSoup", "Selenium", "Scrapy", "MongoDB"],
    github: "https://github.com/Manas470/Data-Science-Projects/tree/main/Web%20Scrapping",
    category: "Data Engineering"
  }
];

export const githubStats = {
  totalRepos: 7,
  totalStars: 1,
  totalCommits: 473,
  contributionStreak: "Active contributor",
  topLanguages: [
    { name: "Python", percentage: 85 },
    { name: "Jupyter Notebook", percentage: 12 },
    { name: "JavaScript", percentage: 3 }
  ]
};

export const experience = [
  {
    company: "Crunch Fitness",
    role: "Data Scientist",
    period: "Current",
    description: "Working on forecasting, churn prediction, and NLP solutions to drive business decisions and improve customer experience."
  }
];

export const learning = [
  "Advanced Generative AI",
  "Vertex AI (GCP)",
  "Snowflake for ML workflows",
  "LLM Fine-tuning",
  "MLOps Automation"
];